import React from 'react';
import { useSelector } from 'react-redux';

import NetworkStatusIndicator from 'components/network-status/NetworkStatusIndicator';
import Timer from 'components/timer/Timer';

const Header = () => {
    const { showTimer } = useSelector((state) => state.certificationReducer);

    return (
        <div>
            { showTimer && ( <Timer /> ) }
            <NetworkStatusIndicator /> {/* Estado de red */}
        </div>
    );
};


export default Header;